<template>
  <div class="main-layout">
    <admin-requests-list />

    <modal
      :show="showModalAdd"
      @close="closeAddModalWindow"
      :dark="true"
      :outside="false"
    >
      <transition name="showmodal">
        <request-add-modal v-if="showModalAdd" @close="closeAddModalWindow" />
      </transition>
    </modal>

    <modal
      :show="showModalDelete"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="toggleShowModalDelete"
    >
      <delete-modal
        :title="$t('global.areUsure').toString()"
        @cancel="toggleShowModalDelete"
        @next="removeAction"
      />
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import adminRequestsList from '@/components/lists/adminRequests/adminRequestsList'
import requestAddModal from '@/components/modals/requests/requestAddModal'

export default {
    components: {
        requestAddModal,
        adminRequestsList,
    },
    computed: {
        ...mapGetters({
            showModalAdd: 'requests/showModalAdd',
            showModalDelete: 'requests/showModalDelete',
            deleteIGetters: 'requests/deleteIGetters',
            cancelDeletionTag: 'requests/deletionStatusGetters',
        }),
    },
    methods: {
        ...mapMutations({
            toggleShowModalAdd: 'requests/toggleShowModalAdd',
            toggleShowModalDelete: 'requests/toggleShowModalDelete',
            clearLandingRequests: 'clearLandingRequests',
            clearAdminRequests: 'clearAdminRequests',
            setIsLastPage: 'setIsLastPage',
            setShowModalAdd: 'requests/setShowModalAdd',
            cleatNotification: 'requests/cleatNotification',
        }),
        ...mapActions({
            remove: 'requests/remove',
            requestForDelete: 'deleteControl/requestForDelete',
            getAdminRequests: 'getAdminRequests',
        }),
        closeAddModalWindow() {
            this.setShowModalAdd(false)
            this.cleatNotification()
        },
        async removeAction() {
            if (!this.$guard('delete', 'Requests')) {
                await this.requestForDelete({
                    id: this.deleteIGetters,
                    type: 'landing/requests',
                })

                this.clearAdminRequests([])
                this.setIsLastPage(false)
                await this.getAdminRequests({})
                this.toggleShowModalDelete()
                return
            }

            await this.remove()
            this.clearAdminRequests([])
            this.setIsLastPage(false)
            await this.getAdminRequests({})
            this.toggleShowModalDelete()
        },
    },
    beforeDestroy() {
        this.clearLandingRequests()

        if (this.showModalAdd) {
            this.closeAddModalWindow()
        }
    },
}
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}

.admin-request {
  width: calc(100% - 140px) !important;
  height: 100%;
  padding: 60px;
}

.show .userlist__subitems {
  transition: 0.3s;
  opacity: 1;
  transform: scale(1);
  height: initial;
  position: static;
}

.list-enter-active {
  transition: all 0.5s;
}

.list-leave-active {
  transition: all 0.5s;
  position: absolute;
  // transform: translateY(-30px);
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
</style>
